import React, { FC } from "react";
import { Form, Input, Button } from "antd";
import { useDispatch } from "react-redux";
import {
  allStakeUserData,
  getClaimByWallet,
  getLotteryByWallet,
  // getWhitelistByWallet,
  stakeUserData,
  // getEthBridgeInfoByWallet,
  // getBscBridgeInfoByWallet,
} from "../../../store/reducer/homePageSlice";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 8 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 8 },
};

export const SearchWalletInput: FC = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const onFinish = (values: { wallet: string }) => {
    const { wallet } = values;
    dispatch(stakeUserData(wallet));
    // dispatch(getWhitelistByWallet(wallet));
    dispatch(getClaimByWallet(wallet));
    dispatch(getLotteryByWallet(wallet));
    dispatch(allStakeUserData(wallet));
    // dispatch(getEthBridgeInfoByWallet(wallet));
    // dispatch(getBscBridgeInfoByWallet(wallet));
  };

  const onReset = () => {
    form.resetFields();
  };

  return (
    <>
      <Form {...layout} form={form} name="walletData" onFinish={onFinish}>
        <Form.Item
          name="wallet"
          label="Wallet Address"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginRight: "15px" }}
          >
            Submit
          </Button>
          <Button htmlType="button" onClick={onReset}>
            Reset
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};
